import React, { useContext, useEffect, useState } from "react";
import Header from "./header";
import Footer from "./footer";
import Counter from "./countertext";
import Testimonials from "./Testimonial";
import HomeCounters from "./Homecounters";
import WhatsAppScrollButton from "./floatingwhatsApp";
import CircularScrollProgress from "./Circularprogress";
import { PartenerSheepDeedService } from "../services/parternshipservice";
import CitySelector from "./User/CitySelectore";
import { ServicesContext } from "../services/ServicesContext";
import { handleRazorpayPayment } from "../services/handlePayment";
import AuthUser from "../services/AuthUser";
import { useNavigate } from "react-router-dom";




function Legalnotice() {

    useEffect(() => {
        const storedUser = localStorage.getItem("user");
        if (storedUser) {
          const parsedUser = JSON.parse(storedUser);
          setNewData((prevData) => ({
            ...prevData,
            user_name: parsedUser.name || "",
            user_email_address: parsedUser.email || "",
            user_phone_number: parsedUser.mobile || "",
            user_related_query: parsedUser.city || "",
          }));
        }
      }, []);

    const [activeQuestion, setActiveQuestion] = useState(null);
     const { http, token } = AuthUser();
   const navigate = useNavigate();
    const toggleQuestion = (questionId) => {
        setActiveQuestion((prev) => (prev === questionId ? null : questionId));
    };

    const [newData, setNewData] = useState({ user_name: '', user_email_address: '', user_phone_number: '', user_related_query: '' })

const [errors, setErrors] = useState({});

   const { services, loading, error } = useContext(ServicesContext);  
   if (loading) {
      return <div>Loading...</div>;  // Show loading state while fetching data
  }

  if (error) {
       return <div>{error}</div> // Show error state if there was an issue fetching data
  }
   const service = services.find(s => s.service_id === 21);

   const validateForm = () => {
      const newErrors = {};

      if (!newData.user_name.trim()) {
         newErrors.user_name = 'Name is required.';
      }else if (!/^[a-zA-Z\s]+$/.test(newData.user_name)) {
         newErrors.user_name = '*Name should only contain letters and spaces.';
       }

      if (!newData.user_email_address.trim()) {
         newErrors.user_email_address = 'Email is required.';
      } else if (!/\S+@\S+\.\S+/.test(newData.user_email_address)) {
         newErrors.user_email = 'Enter a valid email address.';
      }

    //   if (newData.user_phone_number && !/^\d{10}$/.test(newData.user_phone_number)) {
    //      newErrors.user_phone_number = 'Enter a valid 10-digit contact number.';
    //   }


      if (!newData.user_phone_number.trim()) {
        newErrors.user_phone_number = 'number is required.';
      } else if (!/^\d{10}$/.test(newData.user_phone_number)) {
        newErrors.user_phone_number = 'Enter a valid 10-digit contact number.';
      }

      if (!newData.user_related_query) {
         newErrors.user_related_query = 'City/District is required.';
      }

      setErrors(newErrors);
      return Object.keys(newErrors).length === 0; // No errors
   };

  



           const formPutPartenshipdeed = async (e) => {
                 e.preventDefault();

                     // ✅ Check if user is logged in
         //   if (!token) {
    //      alert("Please log in to continue.");
    //      localStorage.setItem("redirectAfterLogin", window.location.pathname); // ⬅️ Save current path
    //     navigate('/login'); // 👈 Use this if you're using React Router
    //     return;
    //  }
                 if (!validateForm()) return;
               
                localStorage.setItem("bookingData", JSON.stringify(newData));

      // Navigate to checkout
      navigate('/checkout', {
         state: {
            service: service,

         }
      });
                  
               };


    return (

        // aboutcompany
        <>



            <div className="hero-area10 header-background">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8">
                            <div className="title title2  ">
                                <div className="headding-shape aniamtion-key-2">
                                    <img src="assets/img/shapes/hero8-shape2.svg" alt="" />
                                </div>
                                <h1 className="sk-text-color">Legal Notice Drafting</h1>
                                <p className="pdrl-text">Start Legal Notice Drafting with Only <span className="text-color"> Rs.{service?.price}/- </span><span>(Final Price, No Hidden Costs)</span>   </p>

                                <p className="pd-text">Legal action cannot proceed without a proper legal notice. Make sure your notice is effective and legally sound by consulting a professional with expertise in legal writing and the correct legal terminology. Dm2Legal offers expert assistance in drafting, reviewing, and responding to legal notices, ensuring your rights are well-protected. For any legal notice-related concerns, trust Dm2Legal to guide you every step of the way!
                                </p>
                                <div className="space30"></div>
                                <div className="banner">
                           <img src="assets/icons/banner.svg" alt="" srcset="" />
                        </div>
                            </div>
                        </div>
                        <div className="col-lg-4">
                            <img className="hero9-shape3 aniamtion-key-1" src="assets/img/shapes/hero9-shape.svg" alt="" />
                            <div className="contact3-form-all">
                                <div className="hadding7">
                                    <h3>Book Service Now </h3>
                                    <p className="pdrl-text"> Start with Only at Rs.{service?.price}/- <br/><span>(Final Price, No Hidden Costs)</span>  </p>
                                    {/* <p className="pdrl-text">at Rs.2251.00 only /- <span>(Including GST)</span></p> */}
                                </div>
                                <form action="#">
                                    <div className="form-input-all">
                                        <div className="form-input-box">
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <div className="input-single6">
                                                        <div className="">
                                                            <label for="">Name<span className="red">*</span></label>{errors.user_name && <p className="error-text">{errors.user_name}</p>}
                                                            <input type="text" placeholder="Enter your Name" value={newData.user_name} onChange={(e) => setNewData({ ...newData, user_name: e.target.value })} />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-12">
                                                    <div className="input-single6">
                                                        <div className="">
                                                            <label for="">Email Address<span className="red">*</span></label>   {errors.user_email_address && <p className="error-text">{errors.user_email_address}</p>}
                                                            <input type="email" placeholder="Enter your Email Address" value={newData.user_email_address} onChange={(e) => setNewData({ ...newData, user_email_address: e.target.value })} />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-12">
                                                    <div className="input-single6">
                                                        <div className="">
                                                            <label for="">Contact Number<span className="red">*</span></label>{errors.user_phone_number && <p className="error-text">{errors.user_phone_number}</p>}
                                                            <input type="number" placeholder="Enter your Contact Number" value={newData.user_phone_number} onChange={(e) => setNewData({ ...newData, user_phone_number: e.target.value })} />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-12">
                                                <CitySelector
                                          newData={newData}
                                          setNewData={setNewData}
                                          fieldKey="user_related_query"
                                          errors={errors}
                                       />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="space20"></div>
                                        <div className="btn-group-2">
                                            <a className="theme-btn-3" href="#" onClick={formPutPartenshipdeed}>Proceed now <span><i className="fa-solid fa-arrow-right"></i></span></a>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="space80"></div>
            <div className="home4-counters">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">

                            <HomeCounters />
                        </div>
                    </div>

                    <div className="space40"></div>

                    <div className="row">

                        <div className="col-lg-12">
                            <p className="pd-text">Received a legal notice or need to draft one? Don’t worry—we’ve got you covered! Connect with our legal experts for prompt assistance and resolve all your legal notice concerns with ease. Contact us today!</p>

                            <p className="pd-text">A legal notice is a formal written communication that informs the recipient of a grievance and the sender’s intent to take legal action if the issue remains unresolved. Serving as a final warning, it urges the recipient to comply with specific demands, offering a chance for an amicable resolution before court proceedings.</p>

                            <p className="pd-text">While it is possible to draft a legal notice on your own, it requires knowledge of legal terminology, conditions, and language. The same applies to the recipient. Once a legal notice is prepared or responded to, no changes can be made, and if the matter goes to court, the notice will be taken as-is. Therefore, it is advisable to seek legal advice before drafting or replying to a legal notice. Contact our legal experts for the best guidance.</p>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-lg-12">
                            <div className="hadding7">
                                <div className="space40"></div>
                                <h2 className="text-center">How to apply</h2>
                                <div className="space20"></div>
                                <img src="assets/img/images/legal251-how-to-apply.png" alt="" />
                                <div className="space20"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="space40"></div>

            <div className="service-binifits9 sp0" id="service2" >
                <div className="space50"></div>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="hadding7">
                                <h2 className="text-center">Documents Required to Draft a Legal Notice </h2>
                                <div className="service-binifits-boxs">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="single-boxs">
                                                &nbsp;&nbsp;
                                                <div className="icon">
                                                    <p> <span><img  className="arow" src="assets/image/doc-01.svg" alt="" /></span>
                                                        Basic information such as the full name, address, and contact details of the sender of the notice.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="single-boxs">
                                                &nbsp;&nbsp;
                                                <div className="icon">
                                                    <p> <span><img  className="arow" src="assets/image/doc-01.svg" alt="" /></span>
                                                        Copies of any contracts, agreements, or relevant documents related to the issue being addressed in the notice.</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="single-boxs">
                                                &nbsp;&nbsp;
                                                <div className="icon">
                                                    <p> <span><img className="arow" src="assets/image/doc-01.svg" alt="" /></span>
                                                        Basic information such as the full name, address, and contact details of the recipient of the notice.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="single-boxs">
                                                &nbsp;&nbsp;
                                                <div className="icon">
                                                    <p> <span><img className="arow" src="assets/image/doc-01.svg" alt="" /></span>
                                                        Clear statement of the action or remedy being demanded from the recipient to rectify the situation.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="single-boxs">
                                                &nbsp;&nbsp;
                                                <div className="icon">
                                                    <p> <span><img className="arow" src="assets/image/doc-01.svg" alt="" /></span>
                                                        Legal grounds or reasons for issuing the notice. This could include breach of contract, violation of rights, non-payment of dues, etc.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="single-boxs">
                                                &nbsp;&nbsp;
                                                <div className="icon">
                                                    <p> <span><img className="arow" src="assets/image/doc-01.svg" alt="" /></span>
                                                        Specify a reasonable deadline by which the recipient must comply with the demands outlined in the notice.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="space50"></div>
                    </div>
                </div>
            </div>


            <div className="space40"></div>


            <div className="service-binifits9 sp0" >
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="hadding7">
                                <h2 className="text-center">How to File a Legal Notice?</h2>
                            </div>
                        </div>
                        <div className="col-lg-8">
                            <div className="hadding7">
                                <div className="space20"></div>

                                <div className="contact6-list">
                                    <ul>
                                        <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Consult a lawyer to assess whether sending a legal notice is the appropriate course of action.</li>
                                        <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Draft a detailed legal notice outlining your grievances and demands.</li>
                                        <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Collect relevant documents and evidence to support your claims.</li>
                                        <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Send the legal notice via registered post, courier, or email, and retain proof of delivery.</li>
                                        <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Keep copies of all communications and documents related to the legal notice.</li>
                                        <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Consider having the legal notice reviewed by legal counsel before sending it through post or courier.</li>
                                        <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Monitor the recipient's response and consider resolving the matter amicably if they comply or initiate negotiations.</li>
                                        <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>If the recipient fails to comply, consult your lawyer to determine the next steps, which may include legal action.</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4">
                            <div className="space30"></div>
                            <img src="assets/img/images/How-to-File-a-Legal-Notice.png" alt="" />
                        </div>
                    </div>

                </div>
            </div>

          

            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="hadding7">
                            <div className="space50"></div>
                            <h2 className="text-center">What are the benefits available to the sender upon sending a legal notice? </h2>
                            <div className="space20"></div>
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className="hadding7">
                            <div className="contact6-list">
                                <ul>
                                    <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Provides formal documentation of the sender's grievances and demands.</li>
                                    <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Helps preserve the sender's legal rights and remedies in India.</li>
                                    <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Establishes a record for potential future legal actions.</li>
                                    <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Demonstrates assertiveness and professionalism in addressing legal matters.</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className="hadding7">
                            <div className="contact6-list">
                                <ul>
                                    <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Serves as a prerequisite for initiating legal proceedings.</li>
                                    <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Encourages negotiation and settlement discussions.</li>
                                    <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Acts as a deterrent against further breaches or misconduct.</li>
                                    <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Indicates the sender's intention to pursue legal proceedings if necessary.</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div>
             

                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="hadding7">
                                <div className="space40"></div>
                                <h2 className="text-center">What are the legal consequences of sending a legal notice?  </h2>
                                <div className="space20"></div>
                                <p className="pd-text">Sending a legal notice is a crucial step in asserting one's rights or informing another party of a legal claim. Legal notices are formal communications that notify the recipient of a specific legal action or obligation. They can be used in various situations, such as breach of contract, eviction proceedings, debt collection, and more. When sending a legal notice, it is essential to ensure that the document is drafted correctly and adheres to the necessary legal requirements. Failure to do so may result in the notice being considered invalid or unenforceable, potentially harming the sender's case.</p>
                                <div className="space20"></div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="contact6-list doc-list">
                                <p className="pd-text">The following are several consequences of sending a legal notice:</p>
                                <ul>
                                    <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Formal Notification</li>
                                    <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Preservation of Rights</li>
                                    <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Prerequisite for Legal Action</li>
                                    <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Encouragement of Negotiation and Settlement</li>
                                    <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Address Proof for Partners</li>
                                    <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Potential for Legal Action</li>
                                    <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Evidence in Court</li>
                                    <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Time Limitations</li>
                                    <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Consequences of Non-Compliance</li>

                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <img src="assets/img/images/What-are-the-legal-consequences-of-sending-a-legal-notice.png" alt="" />
                        </div>
                    </div>
                </div>

                <div className="space40"></div>

                <div className="service-binifits9 sp0" id="service2">
                    <div className="container work8">
                        <div className="row">
                            <div className="col-lg-12 text-center">
                                <div className="hadding7">
                                    <div className="space80"></div>
                                    <h2>Process to send legal notice through Dm2Legal </h2>
                                </div>
                                <div className="partnership-deade-section">
                                    <div className="space40"></div>

                                    <ul className="disc-list">
                                        <li>
                                            <h3>Step 1 <span><img className="arow" src="assets/image/blackarow.svg" alt="" /></span></h3>
                                            <span>Our legal experts will review all the documents you’ve submitted to minimize the risk of incorrect or misleading information, ensuring a smoother process.</span>
                                            <svg className="pointer">
                                                <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
                                            </svg>
                                        </li>
                                        <li>
                                            <h3>Step 2 <span><img className="arow" src="assets/image/blackarow.svg" alt="" /></span></h3>
                                            <span>Our top legal experts are here to assist you with document requirements and licensing needs.</span>
                                            <svg className="pointer">
                                                <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
                                            </svg>
                                        </li>
                                        <li>
                                            <h3>Step 3 <span><img className="arow" src="assets/image/blackarow.svg" alt="" /></span></h3>
                                            <span>The assigned professional will proceed with your documents to draft the legal notice on your behalf.</span>
                                            <svg className="pointer">
                                                <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
                                            </svg>
                                        </li>
                                        <li>
                                            <h3>Step 4 <span><img className="arow" src="assets/image/blackarow.svg" alt="" /></span></h3>
                                            <span>After successfully verifying the documents you provided, our lawyer will draft your legal notice.</span>
                                            <svg className="pointer">
                                                <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
                                            </svg>
                                        </li>
                                        <li>
                                            <h3>Step 5 <span><img className="arow" src="assets/image/done.svg" alt="" /></span> </h3>
                                            <span>It is recommended that you wait until one of our experts contacts you to inform you that your legal notice has been prepared.</span>
                                            <svg className="pointer">
                                                <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
                                            </svg>
                                        </li>
                                    </ul>

                                    <div className="space80"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="space40"></div>

                <div>
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="hadding7">
                                    <h2 className="text-center">How Consulting with Legal Experts is a Key Consideration for Effective Notice Drafting  </h2>
                                </div>
                            </div>
                            <div className="col-lg-8">
                                <div className="hadding7">
                                    <div className="space20"></div>

                                    <div className="contact6-list">
                                        <ul>
                                            <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Legal experts offer insights into relevant laws and regulations.</li>
                                            <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>They provide guidance on drafting language that ensures clarity and effectiveness.</li>
                                            <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Consulting with experts ensures that notices comply with legal standards and requirements.</li>
                                            <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Legal expertise helps identify potential challenges or loopholes.</li>
                                            <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Expert advice enhances the overall credibility and enforceability of the notice.</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4">
                                <div className="space30"></div>
                                <img src="assets/img/images/partnership-deed-image.jpg" alt="" />
                            </div>
                        </div>

                        <div className="space40"></div>
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="hadding7">
                                    <h2 className="text-center">Methods and Considerations for Serving Legal Notice </h2>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="hadding7">
                                    <div className="space20"></div>

                                    <div className="contact6-list">
                                        <ul>
                                            <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Select appropriate delivery methods, such as registered mail or courier services.</li>
                                            <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Ensure accurate addressing to the recipient for legal validity.</li>
                                            <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Retain proof of delivery for future reference or legal proceedings.</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="hadding7">
                                    <div className="space20"></div>

                                    <div className="contact6-list">
                                        <ul>
                                            <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Consult with legal counsel to ensure compliance with local regulations regarding notice delivery.</li>
                                            <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Adhere to legal timelines and requirements for serving notices.</li>
                                            <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Consider alternative methods, such as email, if traditional delivery fails.</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>



                        <div className="row">
                            <div className="col-12">
                                <div className="faq-items" id="masonry-grid">
                                    <div className="mesonry-item general single-price-list">
                                        <div className="faqs inner-faq">
                                            <h2 className="text-center">FAQs about Partnership Deed </h2>
                                            <div className="space30"></div>


                                            <div id="general">


                                                <div className="single-faq">
                                                    <h2
                                                        className={`faq-heading font-f-3 weight-700 ${activeQuestion === 1 ? '' : 'collapsed'
                                                            }`}
                                                        id="faq-heading1"
                                                        onClick={() => toggleQuestion(1)}
                                                    >
                                                        Q1. What is a Legal Notice?
                                                        <span>
                                                            {activeQuestion === 1 ? (
                                                                <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                                            ) : (
                                                                <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                                            )}
                                                        </span>
                                                    </h2>
                                                    <div
                                                        id="collapse1"
                                                        className={`accordion-collapse collapse ${activeQuestion === 1 ? 'show' : ''
                                                            }`}
                                                    >
                                                        <p className="font-f-3 weight-500">
                                                        A legal notice is a formal communication informing someone of a legal issue, requiring action or legal consequences, often before filing a lawsuit.                                                        </p>
                                                    </div>
                                                </div>
                                                <div className="single-faq">
                                                    <h2
                                                        className={`faq-heading font-f-3 weight-700 ${activeQuestion === 2 ? '' : 'collapsed'
                                                            }`}
                                                        id="faq-heading1"
                                                        onClick={() => toggleQuestion(2)}
                                                    >
                                                        Q2. What are the common reasons for sending a legal notice in employment matters?
                                                        <span>
                                                            {activeQuestion === 2 ? (
                                                                <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                                            ) : (
                                                                <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                                            )}
                                                        </span>
                                                    </h2>
                                                    <div
                                                        id="collapse1"
                                                        className={`accordion-collapse collapse ${activeQuestion === 2 ? 'show' : ''
                                                            }`}
                                                    >
                                                        <p className="font-f-3 weight-500">
                                                        A legal notice in employment cases is often served for issues such as wrongful termination, unpaid wages, harassment, breach of contract, discrimination, or violation of labor laws.                                                        </p>
                                                    </div>
                                                </div>
                                                <div className="single-faq">
                                                    <h2
                                                        className={`faq-heading font-f-3 weight-700 ${activeQuestion === 3 ? '' : 'collapsed'
                                                            }`}
                                                        id="faq-heading1"
                                                        onClick={() => toggleQuestion(3)}
                                                    >
                                                        Q3. What actions should I take if I don't receive a response to my legal notice?
                                                        <span>
                                                            {activeQuestion === 3 ? (
                                                                <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                                            ) : (
                                                                <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                                            )}
                                                        </span>
                                                    </h2>
                                                    <div
                                                        id="collapse1"
                                                        className={`accordion-collapse collapse ${activeQuestion === 3 ? 'show' : ''
                                                            }`}
                                                    >
                                                        <p className="font-f-3 weight-500">
                                                        If there's no reply to your legal notice, you can consider filing a lawsuit in the relevant court, depending on the nature of the case, or consult with a lawyer to explore further legal options.                                                        </p>
                                                    </div>
                                                </div>
                                                <div className="single-faq">
                                                    <h2
                                                        className={`faq-heading font-f-3 weight-700 ${activeQuestion === 4 ? '' : 'collapsed'
                                                            }`}
                                                        id="faq-heading1"
                                                        onClick={() => toggleQuestion(4)}
                                                    >
                                                        Q4. Who is typically responsible for drafting a legal notice?
                                                        <span>
                                                            {activeQuestion === 4 ? (
                                                                <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                                            ) : (
                                                                <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                                            )}
                                                        </span>
                                                    </h2>
                                                    <div
                                                        id="collapse1"
                                                        className={`accordion-collapse collapse ${activeQuestion === 4 ? 'show' : ''
                                                            }`}
                                                    >
                                                        <p className="font-f-3 weight-500">
                                                        A legal notice is usually drafted by a lawyer or legal professional, as they are equipped to handle the legal language and ensure the notice is legally sound.                                                        </p>
                                                    </div>
                                                </div>
                                                <div className="single-faq">
                                                    <h2
                                                        className={`faq-heading font-f-3 weight-700 ${activeQuestion === 5 ? '' : 'collapsed'
                                                            }`}
                                                        id="faq-heading1"
                                                        onClick={() => toggleQuestion(5)}
                                                    >
                                                        Q5. Why is filing a legal notice important?
                                                        <span>
                                                            {activeQuestion === 5 ? (
                                                                <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                                            ) : (
                                                                <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                                            )}
                                                        </span>
                                                    </h2>
                                                    <div
                                                        id="collapse1"
                                                        className={`accordion-collapse collapse ${activeQuestion === 5 ? 'show' : ''
                                                            }`}
                                                    >
                                                        <p className="font-f-3 weight-500">
                                                        Filing a legal notice is crucial as it formally informs the recipient of your legal intentions, provides an opportunity to resolve the matter amicably, and is often a prerequisite before taking legal action.
                                                        </p>
                                                    
                                                    </div>
                                                </div>
                                                <div className="single-faq">
                                                    <h2
                                                        className={`faq-heading font-f-3 weight-700 ${activeQuestion === 6 ? '' : 'collapsed'
                                                            }`}
                                                        id="faq-heading1"
                                                        onClick={() => toggleQuestion(6)}
                                                    >
                                                        Q6. What are the methods for sending a legal notice?
                                                        <span>
                                                            {activeQuestion === 6 ? (
                                                                <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                                            ) : (
                                                                <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                                            )}
                                                        </span>
                                                    </h2>
                                                    <div
                                                        id="collapse1"
                                                        className={`accordion-collapse collapse ${activeQuestion === 6 ? 'show' : ''
                                                            }`}
                                                    >
                                                        <p className="font-f-3 weight-500"> A legal notice can be sent through various modes, including registered post with acknowledgment, courier, email, or hand delivery, depending on the legal requirements and the nature of the case.</p>
                                                    </div>
                                                </div>
                                                <div className="single-faq">
                                                    <h2
                                                        className={`faq-heading font-f-3 weight-700 ${activeQuestion === 7 ? '' : 'collapsed'
                                                            }`}
                                                        id="faq-heading1"
                                                        onClick={() => toggleQuestion(7)}
                                                    >
                                                        Q7. What is the deadline for responding to a legal notice?
                                                        <span>
                                                            {activeQuestion === 7 ? (
                                                                <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                                            ) : (
                                                                <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                                            )}
                                                        </span>
                                                    </h2>
                                                    <div
                                                        id="collapse1"
                                                        className={`accordion-collapse collapse ${activeQuestion === 7 ? 'show' : ''
                                                            }`}
                                                    >
                                                        <p className="font-f-3 weight-500">
                                                        The time to respond to a legal notice typically ranges from 15 to 30 days, depending on the nature of the notice and the legal context. It's important to adhere to the time frame specified in the notice to avoid legal consequences.                                                        </p>
                                                    </div>
                                                </div>

                                                <div className="single-faq">
                                                    <h2
                                                        className={`faq-heading font-f-3 weight-700 ${activeQuestion === 8 ? '' : 'collapsed'
                                                            }`}
                                                        id="faq-heading1"
                                                        onClick={() => toggleQuestion(8)}
                                                    >
                                                        Q8.What is meant by a "Show-Cause Notice"?
                                                        <span>
                                                            {activeQuestion === 8 ? (
                                                                <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                                            ) : (
                                                                <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                                            )}
                                                        </span>
                                                    </h2>
                                                    <div
                                                        id="collapse1"
                                                        className={`accordion-collapse collapse ${activeQuestion === 8 ? 'show' : ''
                                                            }`}
                                                    >
                                                        <p className="font-f-3 weight-500">A Show-Cause Notice is a formal notification issued by an authority, asking the recipient to explain or justify their actions or inactions that have led to a potential violation of rules or laws. Failure to provide a valid explanation may result in penalties or legal action.</p>
                                                    </div>
                                                </div>

                                                <div className="single-faq">
                                                    <h2
                                                        className={`faq-heading font-f-3 weight-700 ${activeQuestion === 9 ? '' : 'collapsed'
                                                            }`}
                                                        id="faq-heading1"
                                                        onClick={() => toggleQuestion(9)}
                                                    >
                                                        Q9. What are the advantages of sending a legal notice?
                                                        <span>
                                                            {activeQuestion === 9 ? (
                                                                <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                                            ) : (
                                                                <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                                            )}
                                                        </span>
                                                    </h2>
                                                    <div
                                                        id="collapse1"
                                                        className={`accordion-collapse collapse ${activeQuestion === 9 ? 'show' : ''
                                                            }`}
                                                    >
                                                        <p className="font-f-3 weight-500">
                                                             Sending a legal notice can help in resolving disputes amicably without going to court, act as a formal warning before taking legal action, preserve legal rights, and provide a clear record of communication. It can also encourage the recipient to settle the issue quickly to avoid further legal consequences.
                                                          </p>
                                                    </div>
                                                </div>

                                                <div className="single-faq">
                                                    <h2
                                                        className={`faq-heading font-f-3 weight-700 ${activeQuestion === 10 ? '' : 'collapsed'
                                                            }`}
                                                        id="faq-heading1"
                                                        onClick={() => toggleQuestion(10)}
                                                    >
                                                        Q10. Under which law can a legal notice be filed in civil cases in India?
                                                        <span>
                                                            {activeQuestion === 10 ? (
                                                                <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                                            ) : (
                                                                <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                                            )}
                                                        </span>
                                                    </h2>
                                                    <div
                                                        id="collapse1"
                                                        className={`accordion-collapse collapse ${activeQuestion === 10 ? 'show' : ''
                                                            }`}
                                                    >
                                                        <p className="font-f-3 weight-500">
                                                        In India, a legal notice in civil cases is typically filed under the Code of Civil Procedure, 1908 (CPC). Sections 80 and 81 of the CPC are relevant when sending a legal notice, especially when the notice is intended to be a precursor to filing a civil suit.</p>
                                                    </div>
                                                </div>








                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="space40"></div>

                <Testimonials />

                <div className="sp2 last-section">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-7 m-auto text-center">
                                <div className="hadding7">
                                  
                                    <h2>Why Choose Us? </h2>
                                </div>
                            </div>
                        </div>
                        <div className="space30"></div>
                        <div className="row">
                            <div className="col-lg-6">
                                <div className="service6-box">
                                    <div className="">
                                        <div className="service-box-icon">
                                            <p>1</p>
                                        </div>
                                    </div>
                                    <div className="hadding6">
                                        <h4><span><img className="arow" src="assets/image/icons/growth.svg" alt="" /></span><a href="single-service-1.html" >Growth & Improvement</a></h4>
                                        <p>We are committed to continuous growth and improvement. To us, growth is the fundamental principle of life, and we strive to achieve it. We understand the significance of business growth and its importance to you.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="service6-box">
                                    <div className="">
                                        <div className="service-box-icon">
                                            <p>2</p>
                                        </div>
                                    </div>
                                    <div className="hadding6">
                                        <h4><span><img className="arow" src="assets/image/icons/support.svg" alt="" /></span><a href="single-service-1.html" >Support & Availability</a></h4>
                                        <p>We understand how even a small problem or query can cause frustration. That's why we are always available to provide support and resolve any issues you may have, whenever they arise.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="service6-box">
                                    <div className="">
                                        <div className="service-box-icon">
                                            <p>3</p>
                                        </div>
                                    </div>
                                    <div className="hadding6">
                                        <h4><span><img className="arow" src="assets/image/icons/team.svg" alt="" /></span><a href="single-service-1.html" >Experienced Team</a></h4>
                                        <p>Our team consists of experienced professionals who prioritize professionalism and customer satisfaction above all else. Each member is passionate about their respective field and dedicated to delivering the best service.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="service6-box">
                                    <div className="">
                                        <div className="service-box-icon">
                                            <p>4</p>
                                        </div>
                                    </div>
                                    <div className="hadding6">
                                        <h4><span><img className="arow" src="assets/image/icons/focus.svg" alt="" /></span><a href="single-service-1.html" >Focus</a></h4>
                                        <p>We treat every task with the utmost importance. Our team members remain dedicated and focused on addressing even the smallest needs and requirements of our clients.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="service6-box">
                                    <div className="">
                                        <div className="service-box-icon">
                                            <p>5</p>
                                        </div>
                                    </div>
                                    <div className="hadding6">
                                        <h4><span><img className="arow" src="assets/image/icons/value.svg" alt="" /></span><a href="single-service-1.html" >Value for Money</a></h4>
                                        <p>We understand the value of your hard-earned money. That's why we ensure that every penny you invest with us is utilized in the most effective way, delivering the best value for your investment.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="service6-box">
                                    <div className="">
                                        <div className="service-box-icon">
                                            <p>6</p>
                                        </div>
                                    </div>
                                    <div className="hadding6">
                                        <h4><span><img className="arow" src="assets/image/icons/care.svg" alt="" /></span><a href="single-service-1.html" >Care & Regards</a></h4>
                                        <p>We consider you a part of our family, and your challenges and successes are our own. Your interests are our priority, and we are dedicated to fulfilling them with the utmost care and attention.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="space80"></div>
                <WhatsAppScrollButton />

                <Footer />

                <CircularScrollProgress />



            </div>


        </>
    );
}

export default Legalnotice;